import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { setDrawerAlert } from 'slices/drawer'
import { useFirebaseEvent } from 'hooks'
import { STATICS } from 'statics'
import { downloadFromUrl } from 'utils'
import { Button, StepNumber } from 'components'
import { EVENT_STATUS, FIREBASE_EVENTS, WIFI_BEST_PRACTICES_URL } from 'app-constants'
import { WIFI_TIPS } from '../../constants'
import './style.scss'

export function WifiBestPracticesInitial() {
  const [loadingDownload, setLoadingDownload] = useState(false)
  const { sendEvent } = useFirebaseEvent()
  const dispatch = useDispatch()

  async function handleFileDownload() {
    setLoadingDownload(true)
    try {
      await downloadFromUrl(WIFI_BEST_PRACTICES_URL)
      sendEvent(FIREBASE_EVENTS.CLICK_ON_DOWNLOAD_WIFI_BEST_PRACTICES)
    } catch (error) {
      console.error(error)
      sendEvent(FIREBASE_EVENTS.CLICK_ON_DOWNLOAD_WIFI_BEST_PRACTICES, EVENT_STATUS.ERROR)
      dispatch(
        setDrawerAlert({
          severity: 'error',
          title: 'Não foi possível realizar o download, tente novamente mais tarde.',
        })
      )
    } finally {
      setLoadingDownload(false)
    }
  }

  return (
    <div className='wifi-container'>
      <div className='icon'>
        <STATICS.INFO_CIRCLE />
      </div>
      <h3 className='wifi-title'>Boas práticas de Wi-fi</h3>
      <div className='wifi-container-text'>
        <p className='wifi-text'>
          Bem-vindo ao tópico de Boas Práticas sobre como usufruir da sua Banda Larga e serviços de
          Wi-Fi!!!
        </p>
        <p className='wifi-text'>
          Abaixo seguem algumas dicas de ouro que você poderá encontrar na documentação que estamos
          compartilhando com você
        </p>
      </div>

      <div className='wifi-tips-container'>
        {WIFI_TIPS.map((tips, index) => (
          <div className='wifi-tips-content'>
            <div className='wifi-tips'>
              <StepNumber number={index + 1} />
              <p className='wifi-tips-text'>{tips.text}</p>
            </div>

            {tips.src && (
              <div className='wifi-image'>
                <img src={tips.src} alt={tips.alt} />
              </div>
            )}
          </div>
        ))}
      </div>

      <div className='wifi-button'>
        <Button
          type='button'
          color='primary'
          size='large'
          isLoading={loadingDownload}
          onClick={handleFileDownload}
        >
          Baixar PDF
        </Button>
      </div>
    </div>
  )
}
